import { t } from "i18next";

export function renderTitleNotification(type) {
    let title = t("meetingNotification.notiDefault")
    let content = "";

    if (type === '11-2') return t('meetingNotification.overQuotaStorageLv2')
    if (type === '11-3') return t('meetingNotification.overQuotaStorageLv3')

    if (!type && parseInt(type) !== 0) return title;

    switch (type) {
        case 0:
            title = t('meetingNotification.inviationNoti_title')
            break;
        case 1:
            title = t('meetingNotification.cancelNoti_title');
            break;
        case 2:
            title = t('meetingNotification.updateNoti_title');
            break;
        case 3:
            title = t('meetingNotification.acceptNoti_title');
            break;
        case 4:
            title = t('meetingNotification.denyNoti_title');
            break;
        case 5:
            title = t('meetingNotification.upcomingNoti_title');
            break;
        case 6:
            title = t('meetingNotification.restoreNoti_title');
            break;
        case 7:
            title = t('meetingNotification.deleteNoti_title');
            break;
        case 8:
            title = t('meetingNotification.warningNewDevice');
            break;
        case 9:
            title = t('meetingNotification.verifyEmail');
            break;
        case 10:
            title = t('meetingNotification.shareSub');
            break;
        case 12:
            title = t('meetingNotification.titleActionShareStorage');
            content = <span>{t('meetingNotification.actionShareStorage1')} <span style={{fontWeight: '600'}}>{t('meetingNotification.actionShareStorage2')}</span> {t('meetingNotification.actionShareStorage3')}</span>;
            break;
        default:
            break;
    }

    return {
        title,
        content
    }
}